import { render, staticRenderFns } from "./RestoreLocations.vue?vue&type=template&id=494c7d59&"
import script from "./RestoreLocations.vue?vue&type=script&lang=js&"
export * from "./RestoreLocations.vue?vue&type=script&lang=js&"
import style0 from "./RestoreLocations.vue?vue&type=style&index=0&id=494c7d59&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports